import React from 'react';
import { Box, BoxProps, CircularProgress } from '@mui/material';

import { tGridTemplateColumns } from '../../react-pages/HomePage/OurProducts/OurProducts';
import { IProduct } from '../../interfaces/product';
import CardControlled from './CardControlled';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './Custom.css';

interface CardGridProps extends BoxProps {
  gridColumns: tGridTemplateColumns;
  products: IProduct[];
  imageHeight?: number;
  loading?: boolean;
  defaultGridColumn?: string;
  forProductPage?: boolean;
  slider?: boolean;
}

export const CardGrid: React.FC<CardGridProps> = ({
  products,
  gridColumns,
  imageHeight,
  loading,
  defaultGridColumn = '1fr 1fr 1fr 1fr',
  forProductPage,
  slider,
  ...rest
}) => {
  const settings = {
    dots: true,
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: products.length < 4 ? products.length : 4,
    slidesToScroll: products.length < 4 ? products.length : 4,
    className: 'OurLastProductsSlide',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  if (loading) {
    return (
      <Box sx={{ minHeight: '20rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }

  return slider ? (
    products.length > 0 ? (
      <Slider {...settings}>
        {products?.map((item, index) => {
          return <CardControlled key={index} product={item} columns={gridColumns} imageHeight={imageHeight} />;
        })}
      </Slider>
    ) : (
      <Box sx={{ display: 'flex', justifyContent: 'center', opacity: '0.3', minHeight: 417 }}>
        <h2>There is no any data</h2>
      </Box>
    )
  ) : (
    <Box
      sx={{
        marginTop: forProductPage ? '24px' : '',
        display: 'grid',
        rowGap: '20px',
        columnGap: { xs: '4px', md: '24px' },
        gridTemplateColumns: { xs: gridColumns, md: defaultGridColumn },
        ...rest?.sx,
      }}
      {...rest}
    >
      {products?.map((item, index) => {
        return <CardControlled key={index} product={item} columns={gridColumns} imageHeight={imageHeight} />;
      })}
    </Box>
  );
};
